import qs from 'qs';
import config from '@/shared/constants/config';
import { urlJoin } from '@/shared/helpers/urlJoin';
import ImageSettings from '@/shared/models/ImageSettings';

class ImageService {
  getImage(url, placeholder, settings: ImageSettings) {
    const querystring = qs.stringify(settings, {});
    let finalUrl = url ? url : placeholder;
    if (querystring) {
      finalUrl = finalUrl + '?' + querystring;
    }
    if (finalUrl && finalUrl.indexOf('http') !== 0) {
      finalUrl = urlJoin(config.BASE_URL, finalUrl);
    }
    return finalUrl;
  }
}

const imageService = new ImageService();

export { imageService };
